
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { ContactHistoryActions } from '@actions/index'
import * as fromContactHistory from '@reducers/index'
import { Observable, of } from 'rxjs';
import { ContactHistoryModel, RequestModel } from '@models/index';

@Injectable({ 
    providedIn: 'root'
})

export class ContactHistoryFacadeService {

    constructor(private store: Store<any>, public router: Router, ) { }

    getContactHistory$(): Observable<ContactHistoryModel> {
        return this.store.select(fromContactHistory.getContactHistory)
    }

    getContactHistoryError$(): Observable<string> {
        return this.store.select(fromContactHistory.getErrorContactHistory)
    }

    searchContactHistoryByLocation(contactId: string) {
        const request: RequestModel = {
            params: `contacts/history/location?contactId=${contactId}`,
        }
        this.store.dispatch(ContactHistoryActions.searchContactHistoryByLocation({ request }))
    }

    searchContactHistoryByBusiness(contactId: string) {
        const request: RequestModel = {
            params: `contacts/history?contactId=${contactId}`,
            
        }
        this.store.dispatch(ContactHistoryActions.searchContactHistoryByBusiness({ request }))
    }

    restartCampaignContactHistory(campaignId: string, contactId: string) {
        const request: RequestModel = {
            params: `contacts/restartCampaign`,
            payload: {
                contactId: contactId,
                campaignId: campaignId
            }
        }
        this.store.dispatch(ContactHistoryActions.restartCampaignContactHistory({request}))
    }
}

